import type { WindowKey } from "owa-bizchat-types";
import { getStore } from "../store/store";

/** Indicates if the Tasks Hub is active/visible in the given window. */
export const isTasksHubActive = (windowKey: WindowKey): boolean => {
    return getStore().tasksHubActiveStateByWindow.get(windowKey) ?? false;
};
